<template>
    <div style="position:relative">
        <el-card class="info_two_content">
            <div class="warning_title">
                <el-alert :title="earlyWarningData.warnName" type="warning" effect="dark" :closable="false">
                </el-alert>
            </div>
            <div class="warning_content">
                <div class="info_two_number_box">
                    <div class="info_two_number_text_two" :style="'backgroundColor: '+getColor(earlyWarningData.count)" @click="goEarlyWarningPage">{{earlyWarningData.count}}</div>
                    <div class="info_two_number_title">{{earlyWarningData.warnDesc}}</div>
                </div>
                <div class="earlyWarnAside">
                    <p><span class="asideBox" style="backgroundColor:#00BFDD"></span> (>0条)</p>
                    <p><span class="asideBox" style="backgroundColor:#7874CE"></span> (>30条)</p>
                    <p><span class="asideBox" style="backgroundColor:#FFAB00"></span> (>100条)</p>
                    <p><span class="asideBox" style="backgroundColor:#E64C66"></span> (>300条)</p>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
    export default {
        name:'webIndexEarlyWarning',
        props:{
            earlyWarningData:{
                type: Object,
                require:true
            }
        },
        data(){
            return {
                colorList:['#00BFDD','#7874CE','#FFAB00','#E64C66'],    //一级，二级，三级，四级
            }
        },
        watch:{

        },
        methods:{
            //去预警页面
            goEarlyWarningPage(){
                this.$emit('paramToWeb',this.earlyWarningData.warnPath)
            },
            //获取颜色
            getColor(str){
                str = Number(str)
                if(0<=str && str<=30){
                    return this.colorList[0]
                }else if(30<str && str<=100){
                    return this.colorList[1]
                }else if(100<str && str<=300){
                    return this.colorList[2]
                }else{
                    return this.colorList[3]
                }
            },
        },
        created(){

        },
    }
</script>

<style scoped>
@import url('../assets/fonts/fonts.css');
::v-deep .info_two_content {
    padding: .5rem;
}
::v-deep .el-card__body{
    padding: 7px 0;
}
.warning_title {
    text-align: left;
}
.warning_content{
    display: flex;
    justify-content: space-around;
    align-items: center;
}
.info_two_number_box {
    text-align: center;
    padding: 0 1rem;
}
.info_two_number {
    display: inline-block;
    padding: 0 .5rem;
}

.info_two_number_title {
    font-size: .6rem;
    color: #666666;
    text-align: left;
}

.info_two_number_text {
    width: 4rem;
    height: 4rem;
    line-height: 4rem;
    text-align: center;
    background-color: #E6A23C;
    display: inline-block;
    margin: 1rem auto;
    border-radius: 100%;
    font-size: 1.2rem;
    font-weight: bold;
    color: #FFFFFF;
}
.info_two_number_text_two {
    width: 4rem;
    height: 4rem;
    line-height: 4rem;
    text-align: center;
    background-color: #409EFF;
    display: inline-block;
    margin: 1rem auto;
    font-family: "DIN_Regular";
    font-size: 1.2rem;
    font-weight: bold;
    color: #FFFFFF;
    border-radius: 1rem;
}
.earlyWarnAside{
    font-size: .6rem;
    color:#333;
    
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
}
.earlyWarnAside .asideBox{
    display:inline-block;
    width:10px;
    height:10px;
    margin-top: .3rem;
}
</style>